"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
const Icon = _styledComponents["default"].i.withConfig({
  shouldForwardProp: prop => !['size', 'name', 'iconPosition', 'fit', 'disabled'].includes(prop)
}).attrs(_ref => {
  let {
    size = '20',
    name
  } = _ref;
  return {
    size,
    name,
    className: "icon mi-".concat(size, "px mi-").concat(name)
  };
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([""])));
var _default = exports["default"] = Icon;